import Vue from "vue";
import Vuex from "vuex";
import axios from 'axios';

Vue.use(Vuex, axios)

Vue.config.productionTip = false;

console.log(window.location.hostname)
var API_URL=null;
if(window.location.hostname == "atles.upc.edu"){
  //For production
  API_URL = "https://atles.upc.edu/api/";
}
else if(window.location.hostname == "atlas.upc.edu"){
  //For production
  API_URL = "https://atlas.upc.edu/api/";
}
else if(window.location.hostname == "atlas.pre.upc.edu"){
  //For pre-production
  API_URL = "https://atlas.pre.upc.edu/api/";
}
else{
  //For pre-production
  API_URL = "https://atles.pre.upc.edu/api/";
}
const API=API_URL;

const store = new Vuex.Store({
  state: {
    carregada: false,
    any_actual: ["2010","2020"],
    graf_actual: [],
    clusters: [],
    clusters_seleccionats: [],
    anysSeleccionats: [],
    node_Seleccionat: undefined,
    cluster_marcat: undefined,
    opacitat_arestes: 0.25,
    display_info: false,
    display_cluster: false,
    display_zona: false,
    zona_only_undef: false,
    dades_bar_chart_cluster : {},
    dades_bar_chart_zona : {},
    loader: true,
    heat_map: false,
    api_url: API,
    disciplines_seleccionades: [],
    disciplina_marcar: '',
    disciplina_desmarcar: '',
    amagar_nodes: false,
    disciplines: {
      "Agricultural and Biological Sciences": "rgba(0, 0, 0, 255)",
      "Arts and Humanities": "rgba(84, 0, 96, 255)",
      "Biochemistry, Genetics and Molecular Biology": "rgba(127, 0, 144, 255)",
      "Business, Management and Accounting": "rgba(99, 0, 158, 255)",
      "Chemical Engineering": "rgba(0, 0, 173, 255)",
      "Chemistry": "rgba(0, 0, 213, 255)",
      "Computer Science": "rgba(0, 65, 221, 255)",
      "Decision Sciences": "rgba(0, 130, 221, 255)",
      "Dentistry": "rgba(0, 155, 215, 255)",
      "Earth and Planetary Sciences": "rgba(0, 168, 175, 255)",
      "Economics, Econometrics and Finance": "rgba(0, 170, 147, 255)",
      "Energy": "rgba(0, 163, 83, 255)",
      "Engineering": "rgba(0, 159, 0, 255)",
      "Environmental Science": "rgba(0, 186, 0, 255)",
      "Health Professions": "rgba(0, 212, 0, 255)",
      "Immunology and Microbiology": "rgba(0, 239, 0, 255)",
      "Materials Science": "rgba(44, 255, 0, 255)",
      "Mathematics": "rgba(188, 255, 0, 255)",
      "Medicine": "rgba(228, 241, 0, 255)",
      "Multidisciplinary": "rgba(248, 218, 0, 255)",
      "Neuroscience": "rgba(255, 185, 0, 255)",
      "Nursing": "rgba(255, 141, 0, 255)",
      "Pharmacology, Toxicology and Pharmaceutics": "rgba(255, 21, 0, 255)",
      "Physics and Astronomy": "rgba(233, 0, 0, 255)",
      "Psychology": "rgba(214, 0, 0, 255)",
      "Social Sciences": "rgba(204, 44, 44, 255)",
      "Veterinary": "rgba(204, 204, 204, 255)",
    },
    coordenades_zona: {},
    show_releated_clusters: true,
    related_clusters_dict: {}
  },

  getters: {
    disciplines: state => { return state.disciplines; },
    any_actual: state => { return state.any_actual; },
    nodes: state => { return state.graf_actual.nodes },
    arestes: state => { return state.graf_actual.edges },
    clusters_originals:  state => { return state.graf_actual.muntanyes },
    clusters: state => { return state.clusters },
    clusters_seleccionats: state => { return state.clusters_seleccionats },
    anys_Seleccionats: state => { return state.anysSeleccionats },
    node_Seleccionat: state => {return state.node_Seleccionat },
    cluster_marcat: state => {return state.cluster_marcat },
    display_info: state => {return state.display_info},
    display_cluster: state => {return state.display_cluster},
    display_zona: state => {return state.display_zona},
    zona_only_undef: state => {return state.zona_only_undef},
    dades_bar_chart_cluster: state => {return state.dades_bar_chart_cluster},
    dades_bar_chart_zona: state => {return state.dades_bar_chart_zona},
    loader: state => {return state.loader},
    disciplines_seleccionades: state => {return state.disciplines_seleccionades},
    disciplina_marcar: state => {return state.disciplina_marcar},
    disciplina_desmarcar: state => {return state.disciplina_desmarcar},
    opacitat_arestes: state => {return state.opacitat_arestes},
    api_url: state=> {return state.api_url},
    heat_map: state=> {return state.heat_map},
    amagar_nodes: state=> {return state.amagar_nodes},
    show_releated_clusters: state => {return state.show_releated_clusters},
    related_clusters_dict: state => {return state.related_clusters_dict}
  },

  mutations: {

    inicialitzador(state, aux) {
      state.any_actual = aux;
      state.anysSeleccionats = [parseInt(state.any_actual[0]), parseInt(state.any_actual[1])];
      console.log("Carregant:", state.any_actual);
    },

    LoadGraph(state, graf) {
      console.log('5')
      state.graf_actual = graf;
      console.log('6')
    },
    GetClusters(state, clusters) {
      console.log("carreguem clusters", clusters)
      state.clusters = clusters;
    },
    marcarClusters(state, clusters) {
      if(clusters.length==0) {
        state.display_cluster = false;
        state.cluster_marcat = undefined;
      }
      else {
        state.display_cluster = true;
        state.cluster_marcat = clusters[clusters.length-1];
      }
      state.clusters_seleccionats = clusters;
      state.display_zona = false;
    },
    mostra_zona(state, payload){
      state.coordenades_zona = payload;
      state.display_zona = true;
      state.display_info=false;
      state.node_Seleccionat=undefined;
      state.display_cluster=false;
    },
    actualitza_show_undef(state, undef) {
      state.zona_only_undef = undef;
    },
    anysSeleccionats(state, anys) {
      state.anysSeleccionats = anys;
    },
    SeleccionaNode(state, node){
      state.node_Seleccionat=node;
      state.display_info=true;
      state.display_zona = false;
    },
    AmagaInfo(state){
      state.display_info=false;
      state.node_Seleccionat=undefined;
    },
    Amaga_InfoCluster(state){
      state.display_cluster=false;
    },
    Amaga_zona(state){
      state.display_zona = false;
    },
    Activa_loader(state){
      state.loader=true;
    },
    Desactiva_loader(state){
      state.loader=false;
    },
    MarcarDisciplines(state, disciplines) {
      state.disciplines_seleccionades = disciplines;
    },
    MarcarDisciplina(state, disciplina){
      state.disciplina_marcar=disciplina;
    },
    CanviOpacitat(state, opacitat){
      state.opacitat_arestes=opacitat;
    },
    DesmarcarTotesDisciplines(state){
      state.disciplines_seleccionades = [];
    },
    PintarHeatMap(state, show){
      state.heat_map = show;
    },
    HideNodes(state, show){
      state.amagar_nodes = show;
    },
    ActualitzaDadesBarChartCluster(state, dades) {
      state.dades_bar_chart_cluster = dades;
    },
    ActualitzaDadesBarChartZona(state, dades) {
      state.dades_bar_chart_zona = dades;
    },
    reset(state) {
      state.display_info = false;
      state.display_zona = false;
      state.display_cluster = false;
      state.node_Seleccionat = undefined;
      state.clusters_seleccionats = [];
      state.cluster_marcat = undefined;
      state.heat_map = false;
      state.amagar_nodes = false;
      state.opacitat_arestes = 0.25;
    },
    updateRelatedClusterEntry(state, dades) {
      state.related_clusters_dict[dades['id']] = dades['data'];
    },
    no_connection_error(){}
  },
  actions: {
    inicialitza(context) {
      
      const url = this.getters.api_url + '/get_anys'
      axios.get(url).then(result => {
        context.commit('inicialitzador', result.data);
      }).catch(() => {
        context.commit('no_connection_error');
      });
    },
    MarcarClusters(context, clusters) {
      context.commit('marcarClusters', clusters);
    },
    MarcarDisciplines(context, disciplines) {
      context.commit('MarcarDisciplines', disciplines);
    },   
    MostraZona(context, payload){
      context.commit('mostra_zona', payload);
    },
    ActualitzaShowUndef(context, undef) {
      context.commit('actualitza_show_undef', undef);
    },
    AnysSeleccionats(context, anysSeleccionats) {
      context.commit('anysSeleccionats', anysSeleccionats);
    },
    SeleccionaNode(context, node){
      context.commit('SeleccionaNode', node);
    },
    PintarHeatMap(context, show){
      context.commit('PintarHeatMap', show);
    },
    CanviOpacitat(context, opacitat){
      context.commit('CanviOpacitat', opacitat);
    },
    Amaga_info(context) {
      context.commit('AmagaInfo');
    },
    Amaga_InfoCluster(context){
      context.commit('Amaga_InfoCluster');
    },
    Amaga_zona(context){
      context.commit('Amaga_zona');
    },
    Activa_loader(context){
      console.log("Activa loader")
      context.commit("Activa_loader");
    },
    Desactiva_loader(context){
      console.log("Desactiva loader")
      context.commit("Desactiva_loader");
    },
    DesmarcarTotesLesDisciplines(context){
      console.log("Desmarca Totes disciplines")
      context.commit("DesmarcarTotesDisciplines");
    },
    HideNodes(context, amagar_nodes){
      context.commit("HideNodes", amagar_nodes);
    },
    async loadGraph(context, graph_response) {
      console.log('4')
      context.commit('LoadGraph', graph_response);
      console.log('7')
    },
    actualitza_dades_bar_chart_cluster(context, dades) {
      context.commit('ActualitzaDadesBarChartCluster', dades);
    },
    actualitza_dades_bar_chart_zona(context, dades) {
      context.commit('ActualitzaDadesBarChartZona', dades);
    },
    updateRelatedClusterEntry(context, dades) {
      context.commit("updateRelatedClusterEntry", dades);
    },
    reset(context) {
      context.commit('reset');
    }
  },
});

export default store;
